var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_652_1252",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_652_1252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 10V2H26V10H22ZM35.3 15.5L32.55 12.75L38.15 7L40.95 9.85L35.3 15.5ZM38 26V22H46V26H38ZM22 46V38H26V46H22ZM12.7 15.4L7 9.85L9.85 7.05L15.5 12.7L12.7 15.4ZM38.1 41L32.55 35.25L35.25 32.55L40.95 38.05L38.1 41ZM2 26V22H10V26H2ZM9.85 41L7.05 38.15L12.65 32.55L14.1 33.9L15.55 35.3L9.85 41ZM24 36C20.6667 36 17.8333 34.8333 15.5 32.5C13.1667 30.1667 12 27.3333 12 24C12 20.6667 13.1667 17.8333 15.5 15.5C17.8333 13.1667 20.6667 12 24 12C27.3333 12 30.1667 13.1667 32.5 15.5C34.8333 17.8333 36 20.6667 36 24C36 27.3333 34.8333 30.1667 32.5 32.5C30.1667 34.8333 27.3333 36 24 36ZM24 32C26.2 32 28.0833 31.2167 29.65 29.65C31.2167 28.0833 32 26.2 32 24C32 21.8 31.2167 19.9167 29.65 18.35C28.0833 16.7833 26.2 16 24 16C21.8 16 19.9167 16.7833 18.35 18.35C16.7833 19.9167 16 21.8 16 24C16 26.2 16.7833 28.0833 18.35 29.65C19.9167 31.2167 21.8 32 24 32Z",
    fill: "#ED5272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummer);
export default __webpack_public_path__ + "static/media/Summer.2a4d2b717723a52a22f5a3aa8f11a3cc.svg";
export { ForwardRef as ReactComponent };